import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import MenuIcon from '@material-ui/icons/Menu'
import type { RenderedFunctionComponent } from 'components/initAdminComponents'
import { RootContainer } from 'components/RootContainer/RootContainer'
import React, { useCallback, useState } from 'react'

const HamburgerMenu: RenderedFunctionComponent = () => {
  const [ isOpen, setIsOpen ] = useState(false)

  // TODO: make rid of jQuery when header
  // is rewritten into React
  const mainNav = $('#vr-nav')

  const handleClick = useCallback(() => {
    setIsOpen(prevState => !prevState)
    mainNav.slideToggle()
  }, [])

  return (
    <RootContainer>
      <IconButton color='primary' onClick={ handleClick } disableRipple={ true }>
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
    </RootContainer>
  )
}

HamburgerMenu.queryString = 'div.hamburger-menu'

export { HamburgerMenu }
